import { AuthState } from "@/models/utils/auth-state.interface";
import { LoginRequest } from "@/models/utils/login-request.interface";
import { ContactModuleRequest } from "@/models/utils/contact-module-request.interface";
import { ApiService } from "../api.service";

const CONTROLLER = "authenticate";

class AuthenticateService extends ApiService {
  login(credentials: LoginRequest) {
    return this.post<LoginRequest, AuthState>(
      `${CONTROLLER}/login`,
      credentials
    );
  }

  logout() {
    return this.getAll<void>(`${CONTROLLER}/logout`);
  }

  sendPassword(username: string) {
    return this.post<any, string>(`${CONTROLLER}/sendpassword`, {
      username: username,
    });
  }

  sendMessage(module: ContactModuleRequest) {
    return this.post<ContactModuleRequest, any>(
      `${CONTROLLER}/contactformmessage`,
      module
    );
  }
}

export const authenticate = new AuthenticateService();
